import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ApiService } from "../../../services/api.service";

export const authenticationTokenInterceptor: HttpInterceptorFn = (
	request: HttpRequest<unknown>,
	next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
	const apiService = inject(ApiService);
	const router = inject(Router);

	if (
		request.url.startsWith(environment.BookingApiBaseUrl) ||
		request.url.startsWith(environment.FaceScanApiBaseUrl) ||
		request.url.startsWith(environment.NewApiPath)
	) {
		// api-token ticket used across all API calls
		const ticket = apiService.GetTicket() ?? sessionStorage.getItem("ticket");
		if (ticket) {
			request = request.clone({ setHeaders: { "api-token": ticket } });
		}
	}

	return next(request).pipe(
		catchError((error: unknown) => {
			if (
				error instanceof HttpErrorResponse &&
				(error.status === 401 || error.status === 403)
			) {
				sessionStorage.removeItem("authToken");
				sessionStorage.removeItem("ticket");
				router.navigate(["/welcome"]);
			}
			return throwError(() => error);
		}),
	);
};
